import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";

// import required modules
import { Pagination } from "swiper/modules";
import { useSelector, useDispatch } from "react-redux";
import ImageAdd from "./ImageAdd";
import { delImageInfo } from "../../../redux/slices/mainDataSlice";

export default function ImageInfo({ imageInfo, setImageInfo }) {
  const data = useSelector((state) => state.main.data?.photosData)?.filter(
    (item) => item.clinc_id == "1"
  );
  const isMobile = /iPhone|Android/i.test(navigator.userAgent);
  const [imageAdd, setImageAdd] = useState(false);
  const dispatch = useDispatch();
  return (
    imageInfo && (
      <>
        <div className="image-info-admin" data-aos="fade-in">
          <div
            className="content-layout"
            onClick={() => setImageInfo(false)}
          ></div>
          <div className="add-icon" onClick={() => setImageAdd(true)}>
            <lord-icon
              src="https://cdn.lordicon.com/jgnvfzqg.json"
              trigger="hover"
              className="img"
              style={{ width: "50px", height: "50px" }}
            ></lord-icon>
          </div>
          <Swiper
            pagination={{
              dynamicBullets: true,
            }}
            slidesPerView={"auto"}
            centeredSlides={true}
            spaceBetween={20}
            modules={[Pagination, Navigation]}
            className="container "
          >
            {data?.map((section) => (
              <>
                <SwiperSlide className="section">
                  <div className="image">
                    <img
                      src={`https://api.atharalfarasha.com/public/hakim/${section?.photo_name}`}
                      alt=""
                    />
                  </div>
                  <div
                    className="del-icon"
                    onClick={() => dispatch(delImageInfo(section?.id))}
                  >
                    <lord-icon
                      src="https://cdn.lordicon.com/skkahier.json"
                      trigger="hover"
                      className="img"
                      style={{ width: "50px", height: "50px" }}
                    ></lord-icon>
                  </div>
                  <div className="data">
                    <div className="title">
                      <span>{section?.photo_info}</span>
                    </div>
                  </div>
                </SwiperSlide>
              </>
            ))}
          </Swiper>
        </div>
        <ImageAdd imageAdd={imageAdd} setImageAdd={setImageAdd} />
      </>
    )
  );
}
